<template>
  <section>
    <ul>
      <li v-for="item in items" :key="item.id" class="px-24 py-20">
        <NavBurgerMenuItem
          v-if="!item.children.length"
          :color="item.color"
          :icon="item.icon"
          :title="item.title"
          :url="item.url"
        />

        <NavBurgerMenuUniverse
          v-else
          :id="item.id"
          :image="item.image"
          :title="item.title"
        >
          <Header :color="item.color" :title="item.title" />
          <section class="overflow-auto pb-32">
            <Services
              v-for="service in item.details"
              :key="service.name"
              :service
            />
            <div class="flex flex-col gap-12">
              <aside class="flex gap-8 px-24">
                <div class="body-2 flex-1">
                  {{ i18n(translations.categories) }}
                </div>
                <RevLink class="body-2-link" :to="item.url" @click="toggle">{{
                  i18n(translations.see_all)
                }}</RevLink>
              </aside>
              <ul
                class="grid grid-cols-1 gap-x-16 gap-y-32 px-24 sm:grid-cols-2 md:grid-cols-3"
              >
                <li v-for="child in item.children" :key="child.id">
                  <NavBurgerMenuCategory
                    :image="child.image"
                    :title="child.title"
                    :url="child.url"
                    @click="toggle"
                  />
                </li>
              </ul>
            </div>
          </section>
        </NavBurgerMenuUniverse>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import { useNavigation } from '~/scopes/navigation/composables/useNavigation'

import Header from './Header.vue'
import translations from './MenuSection.translations'
import NavBurgerMenuCategory from './NavBurgerMenuCategory.vue'
import NavBurgerMenuItem from './NavBurgerMenuItem.vue'
import NavBurgerMenuUniverse from './NavBurgerMenuUniverse.vue'
import Services from './Services.vue'

const i18n = useI18n()

const { items, toggle } = useNavigation()
</script>
